import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import svgIcons from "../../../assets/svg/svgIcons";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import HeaderView from "../../../components/admin/headerView";
import { APP_CONFIG, REPORT_TYPES } from "../../../constants/constants";
import ReportTypeSelector from "../components/reportTypeSelector";
import { useCreateCustomReportContext } from "../context/createCustomReport.context";
import ModalCreateCustomReportsStep1 from "../createCustomReport/modalCreateCustomReportsStep1";
import ModalCreateCustomReportsStep2 from "../createCustomReport/modalCreateCustomReportsStep2";
import ModalReportOptions from "./modalReportOptions";
import { TReport, TReportStatus } from "../../../api/types/Report";
import {
  TCreateCustomReportCallbackProps,
  useReportUtils,
} from "../hooks/reportUtils";

const ScreenSelectAReportType = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "reports.selectAType",
  });

  const dispatch = useDispatch();

  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );

  const reportsByType: { [key: string]: TReport[] | TReportStatus } =
    useSelector((state: any) => state.commonReducer.reportsByType);

  const {
    reportName,
    selectedFields,
    setSelectedFields,
    selectedReportId,
    resetCreateCustomReportForms,
  } = useCreateCustomReportContext();

  const { createModifyCustomReportWithFilters } = useReportUtils();

  const hideModal = () => {
    dispatch(
      setModalsData({
        ...modalsState,
        showModalNewCustomReportStep1: false,
        showModalNewCustomReportStep2: false,
        showModalNewCustomReportStep3: false,
      })
    );
  };

  useEffect(() => {
    hideModal();
    return () => {
      resetCreateCustomReportForms();
    };
  }, []);

  return (
    <>
      <HeaderView
        title={t("heading")}
        rightComponent={
          <div className="flex items-center gap-4">
            <AdminFormFieldSubmit
              type="button"
              variant="primary-like"
              label={
                <span className="flex justify-center whitespace-nowrap">
                  {t("add_new_button")}
                  <img
                    className={`ml-2 ${!Array.isArray(reportsByType?.[REPORT_TYPES.NEW_CUSTOM]) ? "opacity-50" : ""}`}
                    src={svgIcons.ButtonIconPlus}
                    alt={t("add_new_button")}
                  />
                </span>
              }
              onClick={() => {
                dispatch(
                  setModalsData({
                    ...modalsState,
                    showModalNewCustomReportStep2: false,
                    showModalNewCustomReportStep1: true,
                  })
                );
              }}
              disabled={
                !Array.isArray(reportsByType?.[REPORT_TYPES.NEW_CUSTOM])
              }
            />

            {/* context moved to router.tsx */}
            {/* <CreateCustomReportContextProvider> */}
            {modalsState?.showModalNewCustomReportStep1 && (
              <ModalCreateCustomReportsStep1 />
            )}
            {modalsState?.showModalNewCustomReportStep2 && (
              <ModalCreateCustomReportsStep2 />
            )}
            {modalsState?.showModalNewCustomReportStep3 &&
              !!selectedReportId && (
                <ModalReportOptions
                  reportType={REPORT_TYPES.NEW_CUSTOM}
                  reportId={selectedReportId}
                  modalVariant={"showModalNewCustomReportStep3"}
                  translationKeyPrefix={
                    "reports.createCustomReport.reportOptions"
                  }
                  onSubmit={({
                    filterValues,
                    reportType,
                    category,
                    reportId,
                    navigate,
                    reportFilters,
                  }) => {
                    // console.log("filterValues", filterValues);
                    // console.log('reportType', reportType);
                    // console.log('category', category);
                    // console.log('reportId', reportId);
                    // console.log('reportFilters', reportFilters);

                    createModifyCustomReportWithFilters({
                      reportName,
                      filterValues,
                      reportType: REPORT_TYPES.CUSTOM, // a newly created custom report will always have type = 2 (CUSTOM)
                      category,
                      reportId,
                      navigate,
                      selectedFields: selectedFields.map((field) => {
                        return {
                          field: Number(field.id),
                          field_title: field.title,
                        };
                      }),
                      reportFilters,
                    } as TCreateCustomReportCallbackProps);
                    // return;

                    // hideModal();

                    // // // navigate to generate report
                    // navigateOnReportOptionsChange({ filterValues, reportType, category, reportId, navigate, reportFilters });

                    // // should we really do this .......?
                    // resetCreateCustomReportForms();
                  }}
                  onClose={() => {
                    hideModal();
                    setSelectedFields([]); // on close, reset selected fields
                  }}
                />
              )}
            {/* </CreateCustomReportContextProvider> */}
          </div>
        }
      />

      <div className={`${APP_CONFIG.DES.DASH.P_HORIZ} py-2`}>
        <ReportTypeSelector />
      </div>
    </>
  );
};

export default ScreenSelectAReportType;
